<template>
  <base-page-layout title="Banners" :filters="['lojas']" :check-all-units-on-init="false" hide-ecommerce-configuration>
    <div class="tabs-button-header">
      <mf-tabs-menu v-model="tab" :tabs="tabs" />
      <div class="tab-buttons">
        <mf-button icon="add" label="Novo banner" @click="redirect" />
      </div>
    </div>

    <div v-if="tab === 0" :key="tab">
      <campaigns-table
        v-if="isFranchisee"
        class="mb-3"
        :franchisee="true"
        :units="units"
        :units-configuration="unitsConfiguration"
        :products="products"
        :itemsFilter="filterListFranchisee[tab]"
        :default-table-sort-by="['updated_at']"
        :default-table-sort-desc="true"
        title="Banners da rede"
      />

      <campaigns-table
        class="mb-3"
        :franchisee="false"
        :units="units"
        :units-configuration="unitsConfiguration"
        :products="products"
        :itemsFilter="filterList[tab]"
        :default-table-sort-by="['updated_at']"
        :default-table-sort-desc="true"
        title="Meus banners"
      />
    </div>

    <div v-if="tab === 1" :key="tab">
      <campaigns-table
        v-if="isFranchisee"
        class="mb-3"
        :franchisee="true"
        :units="units"
        :units-configuration="unitsConfiguration"
        :products="products"
        :itemsFilter="filterListFranchisee[tab]"
        :default-table-sort-by="['updated_at']"
        :default-table-sort-desc="true"
        title="Banners finalizados da rede"
      />

      <campaigns-table
        class="mb-3"
        :franchisee="false"
        :units="units"
        :units-configuration="unitsConfiguration"
        :products="products"
        :itemsFilter="filterList[tab]"
        :default-table-sort-by="['updated_at']"
        :default-table-sort-desc="true"
        title="Meus banners finalizados"
      />
    </div>
  </base-page-layout>
</template>

<script>
import BasePageLayout from '@/components/BasePageLayout.vue'
import CampaignsTable from '../components/CampaignsTable.vue'
import { getStatusLabel } from '@/config/helpers.js'

export default {
  name: 'BannerManagement',
  components: {
    BasePageLayout,
    CampaignsTable,
  },
  data() {
    return {
      tab: 0,
      filterListFranchisee: [
        [
          { label: getStatusLabel('ACTIVE').text, value: 'ACTIVE', color: getStatusLabel('ACTIVE').color, active: true },
          { label: getStatusLabel('SCHEDULED').text, value: 'SCHEDULED', color: getStatusLabel('SCHEDULED').color, active: true },
        ],
        [{ label: getStatusLabel('FINISHED').text, value: 'FINISHED', color: getStatusLabel('FINISHED').color, active: true }],
      ],
      filterList: [
        [
          { label: getStatusLabel('DRAFT').text, value: 'DRAFT', color: getStatusLabel('DRAFT').color, active: true },
          { label: getStatusLabel('ACTIVE').text, value: 'ACTIVE', color: getStatusLabel('ACTIVE').color, active: true },
          { label: getStatusLabel('SCHEDULED').text, value: 'SCHEDULED', color: getStatusLabel('SCHEDULED').color, active: true },
        ],
        [{ label: getStatusLabel('FINISHED').text, value: 'FINISHED', color: getStatusLabel('FINISHED').color, active: true }],
      ],
    }
  },
  computed: {
    units() {
      const units = this.$store.getters.units || []
      return units
    },
    unitsConfiguration() {
      return this.$store.state.filters.unitsConfiguration
    },
    products() {
      return this.$store.state.filters.products
    },
    isFranchisee() {
      if (!this.$getLoggedUser().is_franchisee) return false
      return this.$getLoggedUser().is_franchisee
    },
    tabs() {
      return [
        {
          name: 'Banners ativos',
          itemsLength: 0,
          haveLength: false,
        },
        {
          name: 'Histórico',
          itemsLength: 0,
          haveLength: false,
        },
      ]
    },
  },
  created() {
    this.$store.commit('SET_NAME_IMAGE', '')
  },
  methods: {
    redirect() {
      this.$router.push('/mobile/banners/novo').catch(() => {})
    },
  },
}
</script>

<style lang="scss" scoped>
.tabs-button-header {
  position: relative;
  margin-bottom: 20px;
  .tab-buttons {
    position: absolute;
    top: 5px;
    right: 0;
  }
}
</style>
